import RealPeopleRealConnections from '@containers/Campaigns/RealPeopleRealConnections/RealPeopleRealConnections';

export default RealPeopleRealConnections;